import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/** Fecha corta argentina: 21/08/2026. */
export function formatearFecha(input: string | Date | null | undefined): string {
  if (!input) return "";
  // Una fecha sola ("2026-09-24", la del comprobante) no tiene hora ni zona:
  // `new Date` la toma como medianoche UTC, que en Argentina es el dia
  // anterior a las 21:00, y la mostraba un dia antes. Se escribe como vino.
  const soloFecha = typeof input === "string" ? /^(\d{4})-(\d{2})-(\d{2})$/.exec(input) : null;
  if (soloFecha) return `${soloFecha[3]}/${soloFecha[2]}/${soloFecha[1]}`;
  const d = typeof input === "string" ? new Date(input) : input;
  if (Number.isNaN(d.getTime())) return "";
  return new Intl.DateTimeFormat("es-AR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(d);
}

/** Fecha y hora argentina: 21/08/2026 14:30. */
export function formatearFechaHora(input: string | Date | null | undefined): string {
  if (!input) return "";
  const d = typeof input === "string" ? new Date(input) : input;
  if (Number.isNaN(d.getTime())) return "";
  return new Intl.DateTimeFormat("es-AR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(d);
}
